import React from "react";
import KeyIcon from "../../assets/images/icons/key.png";
import { useSelector } from "react-redux";

const Keys = () => {
  const { currentUser } = useSelector(({ user }) => user);
  return (
    <div className="text-center my-4">
      <div className="mx-auto d-flex justify-content-center align-items-center">
        <img src={KeyIcon} alt="peleIcon" className="keyIcon" />
        <p className="mr-2 mb-0">{currentUser ? currentUser.coin : 0}</p>
      </div>
    </div>
  );
};

export default Keys;
